import DesignerReceiver from './receiver'

export default function init(app, designerToken) {
  const designer = new DesignerReceiver(app.sharedEventBus, designerToken, ({ path, value }) => {
    app.$store.commit('settings/updateSettings', { path, value })
  })

  app.$router.afterEach(to => designer.pageUpdated(to.name))

  if (app.$route && app.$route.name) {
    designer.pageUpdated(app.$route.name)
  }

  designer.start()
    .then(() => console.log('[DesignerReceiver] Connection established.'))
    .catch(err => console.error('[DesignerReceiver] There was an error while trying to establish connection.', err))
}
